import actionTypes from "../webActionTypes";


const reducers = {
    [actionTypes.beginAddEmptyInvoice]: function (state, action) {
      return beginAddEmptyInvoice(state, action);
    },

    [actionTypes.recvAddEmptyInvoiceResult]: function (state, action) {
        return recvAddEmptyInvoiceResult(state, action);
    },

    [actionTypes.recvAddEmptyInvoiceError]: function (state, action) {
        return recvAddEmptyInvoiceError(state, action);
    },
    [actionTypes.beginDeleteEmptyInvoice]: function (state, action) {
        return beginDeleteEmptyInvoice(state, action);
      },
  
      [actionTypes.recvDeleteEmptyInvoiceResult]: function (state, action) {
          return recvDeleteEmptyInvoiceResult(state, action);
      },
  
      [actionTypes.recvDeleteEmptyInvoiceError]: function (state, action) {
          return recvDeleteEmptyInvoiceError(state, action);
      },


    [actionTypes.beginGetEmptyInvoiceList]: function (state, action) {
        return beginGetEmptyInvoiceList(state, action);
    },

    [actionTypes.recvGetEmptyInvoiceListResult]: function (state, action) {
        return recvGetEmptyInvoiceListResult(state, action);
    },

    [actionTypes.recvGetEmptyInvoiceListError]: function (state, action) {
        return recvGetEmptyInvoiceListError(state, action);
    },
    [actionTypes.finishGetEmptyInvoiceYearmonthList]: function (state, action) {
        return finishGetEmptyInvoiceYearmonthList(state, action);
    },
};

export default function createReducers(initialState) {
    return function reducer(state = initialState, action) {
        if (reducers.hasOwnProperty(action.type)) {
            return reducers[action.type](state, action);
        } else {
            return state;
        }
    };
}


function beginGetEmptyInvoiceList(state, action) {
    if (state.isAddEmptyInvoice) return state;

    return Object.assign({}, state, {
        isGetEmptyInvoiceList: true
    });
}

function recvGetEmptyInvoiceListResult(state, action) {

    const {
        payload
    } = action;

    const {totalCount, querykey, ids, data} = payload;

    if (ids.length === 0) {
        return state;
    }
    
    var emptyInvoiceList;

    if(querykey === state.querykey) {
        emptyInvoiceList = Object.assign({}, state.emptyInvoiceList, ids);        
    } else {
        emptyInvoiceList = Object.assign({}, {}, ids);
    }

    const emptyInvoices = Object.assign({}, state.emptyInvoices, data);

    return Object.assign({}, state, {
        emptyInvoiceList,
        emptyInvoices,
        totalCount,
        querykey,
        isGetEmptyInvoiceList: false,
    });
}


function recvGetEmptyInvoiceListError(state, action) {
    if (!state.isAddEmptyInvoice) return state;

    return Object.assign({}, state, {
        isGetEmptyInvoiceList: false
    });
}

function beginAddEmptyInvoice(state, action) {
    if (state.isAddEmptyInvoice) return state;

    return Object.assign({}, state, {
        isAddEmptyInvoice: true
    });
}


function recvAddEmptyInvoiceResult(state, action) {
    if (!state.isAddEmptyInvoice) return state;

    return Object.assign({}, state, {
        isAddEmptyInvoice: false,
    });
}


function recvAddEmptyInvoiceError(state, action) {
    if (!state.isAddEmptyInvoice) return state;

    return Object.assign({}, state, {
        isAddEmptyInvoice: false,
    });
}



function beginDeleteEmptyInvoice(state, action) {
    if (state.isDeleteEmptyInvoice) return state;

    return Object.assign({}, state, {
        isDeleteEmptyInvoice: true
    });
}


function recvDeleteEmptyInvoiceResult(state, action) {
    if (!state.isDeleteEmptyInvoice) return state;

    // Delete EmptyInvoice list and companies

    return Object.assign({}, state, {
        emptyInvoiceList: {},
        emptyInvoices: {},
        totalCount: 0, 
        isDeleteEmptyInvoice: false,
    });
}


function recvDeleteEmptyInvoiceError(state, action) {
    if (!state.isDeleteEmptyInvoice) return state;

    return Object.assign({}, state, {
        isDeleteEmptyInvoice: false,
    });
}

function finishGetEmptyInvoiceYearmonthList(state, action) {

    const payload = action.payload;
    const yearmonthList = payload.yearmonthList || [];

    return Object.assign({}, state, {
        yearmonthList: yearmonthList,
    });
}



// WEBPACK FOOTER //
// ./src/actions/reducers/emptyInvoiceReducers.js